import type { Card } from "./types";

export type CardFocus = "accept" | "ready" | "waiting" | "request" | "completed" | "expired" | "declined" | "locked" | "reviewing" | "blocked" | "other" | "unavailable";
export type CardAction = "accept" | "redeem" | "done";

/** Read-only presentation of the authorized server DTO; never grants permission. */
export function cardPresentation(card: Card, hasShareAccess = false) {
  const sender = card.viewer === "sender", receiver = card.viewer === "receiver";
  const available = ["ok", "flagged"].includes(card.moderation);
  const canAccept = available && card.communicationAllowed !== false &&
    ["sent", "opened"].includes(card.status) &&
    ((card.viewer === "recipient" && card.deliveryMode === "direct") || (card.viewer === "none" && hasShareAccess)) &&
    (!card.locked || (card.deliveryMode === "direct" && card.viewer === "recipient"));
  let focus: CardFocus;
  if (card.status === "revoked" || (!available && card.moderation !== "pending")) focus = "unavailable";
  else if (card.moderation === "pending") focus = "reviewing";
  else if (card.locked) focus = "locked";
  else if (card.viewer === "other") focus = "other";
  else if (card.status === "redeemed") focus = "completed";
  else if (card.status === "expired") focus = "expired";
  else if (card.status === "declined") focus = "declined";
  else if ((sender || receiver) && card.pendingRedemption?.status === "requested") focus = "request";
  else if (card.communicationAllowed === false) focus = "blocked";
  else if (canAccept) focus = "accept";
  else if (receiver && card.status === "accepted" && card.usesLeft > 0) focus = "ready";
  else focus = "waiting";
  const primary: CardAction | null = canAccept ? "accept" :
    focus === "request" && sender ? "done" : focus === "ready" ? "redeem" : null;
  return { focus, primary, sender, receiver,
    canDecline: canAccept && card.viewer === "recipient" && card.deliveryMode === "direct",
    canWithdraw: focus === "request" && receiver,
    reminderAt: focus === "request" && receiver ? Date.parse(card.pendingRedemption!.requestedAt) + 12 * 3600000 : null,
  };
}

export function cardGroup(card: Card): "waiting" | "active" | "history" {
  if (["redeemed", "expired", "declined", "revoked"].includes(card.status)) return "history";
  return card.acceptedAt ? "active" : "waiting";
}
